import { render, staticRenderFns } from "./GetStartedHomeEight.vue?vue&type=template&id=5626c82a&scoped=true&"
import script from "./GetStartedHomeEight.vue?vue&type=script&lang=js&"
export * from "./GetStartedHomeEight.vue?vue&type=script&lang=js&"
import style0 from "./GetStartedHomeEight.vue?vue&type=style&index=0&id=5626c82a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5626c82a",
  null
  
)

export default component.exports